import { render } from "./BaseBadge.vue?vue&type=template&id=ed7a1fda&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=ed7a1fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7a1fda"]])

export default __exports__